import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "../../../../axios/index";

// Context
import { UserContext } from "../../../Context/UserContextProvider";

// components
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import { Pagination, Stack } from "@mui/material";
import StaffColleaguesInfoCard from "./StaffColleaguesInfoCard";
import StaffColleaguesInfoNotif from "./StaffColleaguesInfoNotif";

// Styles
import styles from "./../StaffManagment.module.css";
import Dstyles from "./../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomPagination from "../../../CustomPagination/CustomPagination";

const StaffColleaguesInfo = () => {
  const { userToken, permissions } = useContext(UserContext);
  const [modalShow, setModalShow] = useState(false);
  const history = useHistory();

  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const [isLoading, setIsLoading] = useState(true);

  const [staffSupervisorData, setStaffSupervisorData] = useState([]);

  const [staffConsultantData, setStaffConsultantData] = useState([]);

  useMemo(() => staffConsultantData, [staffConsultantData]);

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)

      const getSuperUsers = await axios.get("Users/GetUsersByRole?permissions=18", {
        headers: { authorization: "Bearer " + userToken },
      });
      const superUser = getSuperUsers.data.data;
      setStaffSupervisorData(superUser);
      // console.log(getSuperUsers)

      const getConsultant = await axios.get("Consultant?Take=10", {
        headers: { authorization: "Bearer " + userToken },
      });
      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getConsultant.data.data.pageCount };
      });

      const consultant = getConsultant.data.data.data;
      setStaffConsultantData(consultant);
      // console.log(consultant)

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken]);

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`my-3 pb-4 px-0 ${styles.file_cards_container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                  <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                    <a href="#" onClick={history.goBack}>
                      <img className="ms-2" src={arrowIcon} alt="icon" />
                    </a>
                    <div className={styles.text1}>
                      {permissions?.find(item => item === 18) === 18
                        ? "اطلاعات مشاوران منطقه"
                        : permissions?.find(item => item === 15) === 15 && "اطلاعات و دسترسی پرسنل"}
                    </div>
                  </div>
                </div>

                {/* Total Staff Managment Info */}
                {permissions?.find(item => item === 15) === 15 && <StaffColleaguesInfoNotif />}

                {permissions?.find(item => item === 15) === 15 && (
                  <div dir="rtl" className={`mt-4 pt-4 mx-4 px-2`}>
                    <h3 className={`mb-4 text-right ${styles.title_staff_colleagues_info}`}> سرپرست ها </h3>
                    <StaffColleaguesInfoCard staffColleaguesData={staffSupervisorData} setStaffSupervisorData={setStaffSupervisorData} />
                  </div>
                )}

                {permissions?.find(item => item === 15) === 15 ? (
                  <div dir="rtl" className={`mt-4 pt-4 mx-4 px-2`}>
                    <h3 className={`mb-4 text-right ${styles.title_staff_colleagues_info}`}> مشاوران </h3>
                    <StaffColleaguesInfoCard staffConsultantData={staffConsultantData} setStaffConsultantData={setStaffConsultantData} consultant />
                  </div>
                ) : (
                  permissions?.find(item => item === 18) === 18 && (
                    <div dir="rtl" className={`mt-4 pt-4 mx-4 px-2`}>
                      <StaffColleaguesInfoCard staffConsultantData={staffConsultantData} setStaffConsultantData={setStaffConsultantData} consultant />
                    </div>
                  )
                )}

                <Stack
                  className={Dstyles.pagination}
                  spacing={1}
                  sx={{
                    direction: "ltr",
                    bottom: "0",
                    height: "85px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center !important",
                  }}>
                  <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                </Stack>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu managePersonal manageStaffInfo />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getSuperUsers = await axios.get(`Users/GetUsersByRole?permissions=18&PageId=${value}`, {
      headers: { authorization: "Bearer " + userToken },
    });
    const superUser = getSuperUsers.data.data;
    setStaffSupervisorData(superUser);

    const getConsultant = await axios.get(`Consultant?PageId=${value}`, {
      headers: { authorization: "Bearer " + userToken },
    });
    setPage(prev => {
      return { ...prev, pageCount: getConsultant.data.data.pageCount, pageNumber: value };
    });
    const consultant = getConsultant.data.data.data;
    setStaffConsultantData(consultant);
    setIsLoading(false);
  }
};

export default StaffColleaguesInfo;
